import { ICalendar } from  '@/components/elements/plannerSettings/Calendars';
import React, { useContext, useEffect, useState } from 'react';
import { useParams  } from "react-router";
import useHTTP from './useHTTP';
import { IloadingType, PlannerSettingsContext } from '@/context/PlannerSettingsContext';

const useSelectedCalendar = () => {

    const [selectedCalendar, setSelectedCalendar] = useState<ICalendar>(null);

    const {setLoading, setLoadingType} = useContext(PlannerSettingsContext);

    const { id } = useParams();
    const { get } = useHTTP();
    
    useEffect(() => {
        
        if (id && (selectedCalendar === null || selectedCalendar.id !== Number(id))){

            setLoading(true)
            setLoadingType(IloadingType.loading)
            
            get(`planner/calendar`).then(({data}) => {

                if (data.calendars){
                    
                    const selected = data.calendars.find(x => x.id === parseInt(id))

                    if (selected){
                        setSelectedCalendar(selected)
                    }
                }
            }).finally(() => {
                setLoading(false)
            })
        }

    }, [id])
    
    return selectedCalendar
};

export default useSelectedCalendar;
